/**
 * @module builder
 */
import type { QuoteDocument, OrderItem, OptionsDocument } from 'paintscout'

import findIndex from 'lodash/findIndex'
import { getGroup } from '../get-group'

import { calculateQuote } from '../../util'

export default function deleteGroup(args: {
  quote: QuoteDocument
  options: OptionsDocument
  key: string
  calculate?: boolean
}): QuoteDocument {
  const { quote, options, key, calculate } = args

  const group = getGroup({ quote, key })

  const groups = { ...quote.groups }
  delete groups[key]

  const areaOrder: OrderItem[] = [...quote.order.area]
  const areaOrderIndex = findIndex(areaOrder, { key: group.key })
  areaOrder[areaOrderIndex]._deleted = true

  const substrateOrder: OrderItem[] = [...quote.order.substrate]
  const substrateOrderIndex = findIndex(substrateOrder, { key: group.key })
  substrateOrder[substrateOrderIndex]._deleted = true

  group.children.forEach((childKey) => {
    const areaChildIndex = findIndex(areaOrder, { key: childKey })
    if (areaChildIndex > -1) {
      delete areaOrder[areaChildIndex].parent
    }

    const substrateChildIndex = findIndex(substrateOrder, { key: childKey })
    if (substrateChildIndex > -1) {
      delete substrateOrder[substrateChildIndex].parent
    }
  })

  const updatedQuote = {
    ...quote,
    groups,
    order: {
      ...quote.order,
      area: areaOrder,
      substrate: substrateOrder
    }
  }

  return calculate === false ? updatedQuote : calculateQuote({ quote: updatedQuote, options })
}
